module.exports = __webpack_public_path__ + "static/media/ic_rectangle.495fc0b7.svg";